import { FeedItem } from '@knocklabs/client';

/**
 * Returns Knock-rendered HTML for the notification body block, if present.
 */
export function getNotificationItemBody(item: FeedItem): string | null {
  const namedBody = item.blocks?.find((block) => block.name === 'body');
  if (namedBody && 'rendered' in namedBody && typeof namedBody.rendered === 'string') {
    const html = namedBody.rendered.trim();
    return html || null;
  }

  const textBlock = item.blocks?.find(
    (block) => (block.type === 'text' || block.type === 'markdown') && block.name !== 'action_url',
  );

  if (textBlock && 'rendered' in textBlock && typeof textBlock.rendered === 'string') {
    const html = textBlock.rendered.trim();
    return html || null;
  }

  return null;
}
